
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import * as z from 'zod';
import { useToast } from './use-toast';

// Define the form schema - ensure name is required
const portfolioFormSchema = z.object({
  name: z.string().min(1, "Portfolio name is required")
});

// Export the type for use in other components
export type PortfolioFormValues = z.infer<typeof portfolioFormSchema>;

export const useAddPortfolioForm = (
  onAddPortfolio: (data: PortfolioFormValues) => void,
  onSuccess?: () => void
) => {
  const { toast } = useToast();

  const form = useForm<PortfolioFormValues>({
    resolver: zodResolver(portfolioFormSchema),
    defaultValues: {
      name: ''
    }
  });

  const onSubmit = (data: PortfolioFormValues) => {
    try {
      console.log('Portfolio form submitted with data:', data);
      onAddPortfolio(data);
      
      // Only call onSuccess if explicitly provided
      if (onSuccess) {
        onSuccess();
      }
      
    } catch (error) {
      console.error('Error submitting portfolio form:', error);
      toast({
        title: 'Error',
        description: 'There was a problem creating your portfolio.',
        variant: 'destructive',
      });
    }
  };

  return { form, onSubmit };
};
